import { useQuery } from '@tanstack/react-query';
import { serviceApiV3 } from '@/api/client';
import { mediaBase } from './configs';
import type { LmsAuditsRequest, LmsAuditsResponse } from './live-audits-types';

// ============================================
// Query keys
// ============================================

export const liveAuditKeys = {
  list: (serviceId: string, params: LmsAuditsRequest) =>
    ['livestream', 'audits', serviceId, params] as const,
};

// ============================================
// Queries
// ============================================

export function useLmsAudits(
  serviceId: string,
  params: LmsAuditsRequest,
) {
  return useQuery<LmsAuditsResponse>({
    queryKey: liveAuditKeys.list(serviceId, params),
    enabled: !!serviceId,
    queryFn: async () => {
      const p: Record<string, string> = {
        page: String(params.page),
        per_page: String(params.perPage),
        action: params.action === 'all' ? '' : params.action,
      };
      if (params.account) p.account = params.account;
      if (params.startDate) p.start_date = params.startDate;
      if (params.endDate) p.end_date = params.endDate;

      const res = await serviceApiV3.get(`${mediaBase(serviceId, 'streams')}/audits`, { params: p });
      return (
        res.data?.data ??
        res.data ?? {
          total_count: 0,
          page_size: params.perPage,
          start_index: 0,
          end_index: 0,
          current_page_number: params.page,
          total_page_number: 0,
          has_pre: false,
          has_next: false,
          list: [],
        }
      );
    },
  });
}
